import { DiscountProps } from './type';

const formatPriceWithCommas = (price: string) => {
  return price.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const getCurrencySymbol = (currency: string) => {
  if (currency === 'INR') {
    return '₹';
  }
};

export const getFormattedPrice = (price: number | undefined) => {
  if (!price) {
    return '';
  }

  const amount = price.toString();
  const formattedPrice = `${getCurrencySymbol('INR')}${
    price >= 0 ? formatPriceWithCommas(amount) : 0
  }`;
  return formattedPrice;
};

export const convertDurationToYears = (validity: number) => {
  return validity / 12;
};

export const formatDiscount = (discount: string, unit: string) => {
  const value = discount.replace(/%/g, '');
  if (parseInt(value) === 0) {
    return '';
  }
  if (unit === 'percentage') {
    return `${value}% OFF`;
  }
  if (discount.endsWith('%')) {
    return `${value}% OFF`;
  }
  const currencySymbol = getCurrencySymbol('INR');
  return `${currencySymbol} ${discount} OFF`;
};

export const checkIfDiscountAvailable = (props: DiscountProps) => {
  const { discount } = props;
  const formattedDiscountValue = formatDiscount(
    discount?.discountValue || '',
    discount?.discountUnit || '',
  );
  if (
    discount?.actualPrice &&
    discount?.actualPrice > 0 &&
    discount.discountValue &&
    !(formattedDiscountValue === '')
  ) {
    return true;
  }
  return false;
};
